'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../../utils/index.js');

var _index2 = _interopRequireDefault(_index);

var _consts = require('@wix/photography-client-lib/dist/src/utils/consts');

var _consts2 = _interopRequireDefault(_consts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageItem = function (_React$Component) {
  (0, _inherits3.default)(ImageItem, _React$Component);

  function ImageItem() {
    (0, _classCallCheck3.default)(this, ImageItem);
    return (0, _possibleConstructorReturn3.default)(this, (ImageItem.__proto__ || (0, _getPrototypeOf2.default)(ImageItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(ImageItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      try {
        this.props.actions.setItemLoaded();
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isThumbnail = _props.isThumbnail,
          alt = _props.alt,
          visible = _props.visible,
          loaded = _props.loaded,
          displayed = _props.displayed,
          styleParams = _props.styleParams,
          imageDimensions = _props.imageDimensions,
          resized_url = _props.resized_url,
          id = _props.id,
          actions = _props.actions,
          settings = _props.settings;

      var imageProps = settings && settings.imageProps && typeof settings.imageProps === 'function' ? settings.imageProps(id) : {};
      var backgroundStyle = {}; //remove this inline style if rendered padding (using css) is used

      var _ref = imageDimensions || {},
          marginLeft = _ref.marginLeft,
          marginTop = _ref.marginTop,
          restOfDimensions = (0, _objectWithoutProperties3.default)(_ref, ['marginLeft', 'marginTop']);

      var imageItemClassName = ['gallery-item-content', 'image-item', 'gallery-item-visible', 'gallery-item', 'gallery-item-preloaded', styleParams.cubeImages && styleParams.cubeType === 'fit' ? 'grid-fit' : '', styleParams.imageLoadingMode === _consts2.default.loadingMode.COLOR ? 'load-with-color' : ''].join(' ');

      return _react2.default.createElement(
        'div',
        {
          className: imageItemClassName,
          onTouchStart: actions.handleItemMouseDown,
          onTouchEnd: actions.handleItemMouseUp,
          key: 'image_container-' + id,
          'data-hook': 'image-item',
          style: displayed ? {} : (0, _extends3.default)({}, backgroundStyle, restOfDimensions)
        },
        this.useCssScrolling ? _react2.default.createElement('canvas', (0, _extends3.default)({
          key: (styleParams.cubeImages && styleParams.cubeType === 'fill' ? 'cubed-' : '') + 'image',
          className: 'gallery-item-visible gallery-item gallery-item-hidden gallery-item-preloaded',
          role: 'img',
          'arial-label': alt,
          'data-src': resized_url.img,
          style: restOfDimensions
        }, imageProps)) : _react2.default.createElement('img', (0, _extends3.default)({
          onLoad: actions.setItemLoaded,
          key: (styleParams.cubeImages && styleParams.cubeType === 'fill' ? 'cubed-' : '') + 'image',
          className: 'gallery-item-visible gallery-item ' + (loaded ? 'gallery-item-loaded' : 'gallery-item-hidden'),
          src: resized_url.img,
          alt: isThumbnail ? '' : alt,
          onError: actions.setItemError,
          style: restOfDimensions
        }, imageProps))
      );
    }
  }]);
  return ImageItem;
}(_react2.default.Component);

exports.default = ImageItem;